import React, { useState, useEffect } from 'react';
import { getQuestionLimit } from '../../services/userAPIService';
import PaywallComponent from './PaywallComponent';

const TrialVolumeProgress = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [limitData, setLimitData] = useState(null);
    const [showPaywall, setShowPaywall] = useState(false);

    useEffect(() => {
        const fetchLimitData = async () => {
            try {
                const data = await getQuestionLimit();
                setLimitData(data);
                setLoading(false);
            } catch (err) {
                setError('Failed to load question limit data');
                setLoading(false);
            }
        };

        fetchLimitData();
    }, []);

    const handleClosePaywall = () => {
        setShowPaywall(false);
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center p-4">
                <span className="loading loading-spinner loading-md text-primary"></span>
            </div>
        );
    }

    if (error) {
        return (
            <div className="text-sm text-error">
                {error}
            </div>
        );
    }

    const remainingQuestions = Math.max(0, limitData.total_limit - limitData.questions_answered_total);
    const progressWidth = `${(remainingQuestions / limitData.total_limit) * 100}%`;

    let statusStyles;
    if (remainingQuestions <= 50) {
        statusStyles = {
            badge: "badge-error",
            progress: "bg-error",
            ring: "ring-error/20",
            dot: "bg-error",
            border: "border-error",
            message: "Du hast das Limit erreicht!"
        };
    } else if (remainingQuestions <= 120) {
        statusStyles = {
            badge: "badge-warning",
            progress: "bg-warning",
            ring: "ring-warning/20",
            dot: "bg-warning",
            border: "border-warning",
            message: "Achtung: Du näherst dich dem Ende des Testvolumens!"
        };
    } else {
        statusStyles = {
            badge: "badge-primary",
            progress: "bg-primary",
            ring: "ring-primary/20",
            dot: "bg-primary",
            border: "border-base-200",
            message: `Du kannst noch ${remainingQuestions} weitere Fragen beantworten.`
        };
    }

    return (
        <>
            {showPaywall && (
                <PaywallComponent
                    onClose={handleClosePaywall}
                    canClose={true}
                />
            )}
            <div className={`space-y-3 bg-base-200 p-4 border-2 ${statusStyles.border} rounded-lg card shadow-lg ring-1 ring-base-content/5`}>
                {/* Title and Counter */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                    <div className="flex items-center gap-2">
                        <h3 className="font-medium text-sm">Mein-SKS Testfragen</h3>
                    </div>
                    <div className="flex items-center gap-1.5 text-xs">
                        <div className={`w-2 h-2 rounded-full ${statusStyles.dot} ring-2 ${statusStyles.ring}`} />
                        <span>{remainingQuestions} von {limitData.total_limit} verfügbar</span>
                    </div>
                </div>

                {/* Progress Bar */}
                <div className="h-2.5 w-full rounded-full overflow-hidden bg-base-300/50 ring-1 ring-base-content/10">
                    <div
                        className={`h-full transition-all duration-300 ${statusStyles.progress}`}
                        style={{ width: progressWidth }}
                    />
                </div>

                {/* Info Text and Upgrade Button */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                    <p className="text-xs text-base-content/70">
                        {statusStyles.message}
                    </p>

                    <button
                        onClick={() => setShowPaywall(true)}
                        className={`btn btn-sm ${remainingQuestions <= 50 ? 'btn-error' : statusStyles.dot}`}
                    >
                        Jetzt upgraden
                    </button>
                </div>
            </div>
        </>
    );
};

export default TrialVolumeProgress; 